// extracted by mini-css-extract-plugin
export default {"pic":"product_pic__-kHfL"};